export default __webpack_public_path__ + "images/SA.abfc5af.png";